import React from 'react';

export const PTComment = () => {
  return (
    <React.Fragment>
      <h3>Practice Tests</h3>
      <p>
        <span>
          An essential part of preparation as you near your test date should be using the four official UCAT practice
          tests under timed conditions.
        </span>
      </p>
      <p>
        <span>
          The practice tests are not set up to save your result or provide a score. The final review screen shows which
          of your answers are correct / incorrect.&nbsp;
          <em>Please note that when you take the live test your correct and incorrect answers will not be reported.</em>
        </span>
      </p>
      <p>
        <span>
          These are intended to be&nbsp;viewed&nbsp;on desktop rather than mobile devices, so as to accurately reflect
          the live test experience.
        </span>
      </p>
    </React.Fragment>
  );
};
